var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendorsmanagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "vendors management",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M4 6h16a1 1 0 0 1 1 1v4h2V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9v-2H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z",
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M22.71 18.43c.03-.29.04-.58.01-.86l1.07-.85c.1-.08.12-.21.06-.32l-1.03-1.79c-.06-.11-.19-.15-.31-.11l-1.28.5a3.44 3.44 0 0 0-.75-.42l-.2-1.36a.25.25 0 0 0-.25-.22h-2.07a.26.26 0 0 0-.25.21l-.2 1.36c-.26.11-.51.26-.74.42l-1.28-.5a.24.24 0 0 0-.31.11l-1.03 1.79a.25.25 0 0 0 .06.32l1.07.86c-.03.29-.04.58-.01.86l-1.07.85a.25.25 0 0 0-.06.32l1.03 1.79c.06.11.19.15.31.11l1.27-.5c.23.17.48.31.75.42l.2 1.36c.02.12.12.21.25.21h2.07c.12 0 .23-.09.25-.21l.2-1.36c.26-.11.51-.26.74-.42l1.28.5c.12.05.25 0 .31-.11l1.03-1.79a.25.25 0 0 0-.06-.32l-1.06-.85ZM19 19.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorsmanagement);
export default __webpack_public_path__ + "static/media/vendors management.f95821e55dae84c853645a278343c58c.svg";
export { ForwardRef as ReactComponent };